import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewChild, Input, NgModule } from '@angular/core';

class ChartjsComponent {
    constructor(zone) {
        this.zone = zone;
        this.height = 150;
        this.width = 300;
    }
    ngAfterViewInit() {
        this.renderChart();
    }
    ngOnChanges() {
        if (this.chartInstance && this.redraw) {
            this.chartInstance.destroy();
            this.renderChart();
            return;
        }
        this.updateChart();
    }
    updateChart() {
        if (!this.chartInstance) {
            return;
        }
        this.chartInstance.data = this.data;
        this.chartInstance.options = this.options;
        this.chartInstance.update(this.updateMode);
    }
    renderChart() {
        const node = this.ref.nativeElement;
        // In order to allow for universal rendering, we import chartjs runtime with `require` to prevent node errors
        // eslint-disable-next-line @typescript-eslint/naming-convention,@typescript-eslint/no-shadow
        this.zone.runOutsideAngular(() => __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const { Chart } = yield import('chart.js');
            this.chartInstance = new Chart(node, {
                type: this.type,
                data: this.data,
                options: this.options,
                plugins: this.plugins,
            });
        }));
    }
}
ChartjsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.3", ngImport: i0, type: ChartjsComponent, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
ChartjsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.0.3", type: ChartjsComponent, selector: "ngx-chartjs", inputs: { type: "type", data: "data", options: "options", height: "height", width: "width", plugins: "plugins", redraw: "redraw", updateMode: "updateMode" }, viewQueries: [{ propertyName: "ref", first: true, predicate: ["ref"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `<canvas #ref [attr.height]="height" [attr.width]="width"></canvas>`, isInline: true, styles: [":host{display:block}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.3", ngImport: i0, type: ChartjsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ngx-chartjs',
                    template: `<canvas #ref [attr.height]="height" [attr.width]="width"></canvas>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [':host { display: block }'],
                }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }]; }, propDecorators: { ref: [{
                type: ViewChild,
                args: ['ref']
            }], type: [{
                type: Input
            }], data: [{
                type: Input
            }], options: [{
                type: Input
            }], height: [{
                type: Input
            }], width: [{
                type: Input
            }], plugins: [{
                type: Input
            }], redraw: [{
                type: Input
            }], updateMode: [{
                type: Input
            }] } });

class ChartjsModule {
}
ChartjsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.0.3", ngImport: i0, type: ChartjsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ChartjsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.0.3", ngImport: i0, type: ChartjsModule, declarations: [ChartjsComponent], exports: [ChartjsComponent] });
ChartjsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.0.3", ngImport: i0, type: ChartjsModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.0.3", ngImport: i0, type: ChartjsModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [ChartjsComponent],
                    declarations: [ChartjsComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ChartjsComponent, ChartjsModule };
